import { CallbackInterface } from 'recoil';
import { getPromoPriveSSORedirectUrl } from '../actions';
import {
  userLoaderState,
} from '../state';
import { setSnackbarError } from '../common';

export const handlePromoPriveSSORedirectCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set(userLoaderState, true);
    try {
      const res = await getPromoPriveSSORedirectUrl();
      window.location.href = res?.data?.ssoUrl;
    } catch (error: any) {
      setSnackbarError(set, error);
      set(userLoaderState, false);
    }
  };